<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre"><div class="pre" id="pre-004"><a id="page_XII"><h1 class="pre_tit"><span>ACKNOWLEDGEMENTS</span></h1><div class="dev"><p class="txt_courant_ssalinea">I should like to thank Ruth McCurry, Gordon McConville and Alan Millard for their advice and encouragement and my son Christopher for the maps and graphics.</p></div></a></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre5.vue?846bd88e